import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useIntercomData = (config = { enabled: false }) =>
  useQuery({
    ...config,
    queryKey: "intercom",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/users/intercom`,
        signal,
      }),
  });
